import React, { useEffect, useState, useCallback } from "react";
import { getUrl } from "aws-amplify/storage";
import { Typography, Box, Stack } from "@mui/material";

const SubmittedFilesPreview = ({ content }) => {
  const [trailerFileUrl, setTrailerFileUrl] = useState(null);
  const [masterFile, setMasterFile] = useState(null);
  const [posters, setPosters] = useState([]);
  const typeOfMasterFile = content?.filePath?.split("/")?.pop();
  console.log(typeOfMasterFile, "type of master file");
  const [filesFetched, setFilesFetched] = useState(false);

  const fetchContentFiles = useCallback(async () => {
    if (filesFetched) return; // Prevent fetching if already fetched

    try {
      if (content?.trailerFilePath) {
        const response = await getUrl({
          key: content?.trailerFilePath,
          options: { validateObjectExistence: true },
        });
        setTrailerFileUrl(response?.url?.href);
      }

      if (content?.filePath) {
        const response = await getUrl({
          key: content?.filePath,
          options: { validateObjectExistence: true },
        });
        setMasterFile(response?.url?.href);
      }

      if (content?.posters?.length) {
        const postersPromises = content.posters.map(async (poster) => {
          const response = await getUrl({
            key: poster,
            options: { validateObjectExistence: true },
          });
          return response?.url?.href;
        });

        // Use Promise.all to fetch all posters URLs concurrently
        const postersUrls = await Promise.all(postersPromises);
        setPosters(postersUrls);
      }

      setFilesFetched(true); // Set fetch status to true after fetching
    } catch (error) {
      console.log(error);
    }
  }, [content, getUrl, filesFetched]);

  useEffect(() => {
    fetchContentFiles();
  }, [fetchContentFiles]);
  return (
    <Stack alignItems="center">
      {posters?.length > 0 &&
        posters.map((poster, key) => (
          <Box marginY={2} key={key}>
            <img src={poster} width={200} />
          </Box>
        ))}

      {trailerFileUrl && (
        <Box marginY={2}>
          <Typography>Trailer File</Typography>
          <video
            src={trailerFileUrl}
            style={{ width: "100%" }}
            controls
            controlsList="nodownload"
          />
        </Box>
      )}
      {masterFile && (
        <Box marginY={2}>
          <Typography>Content Main File</Typography>
          {typeOfMasterFile.includes("mp4") ? (
            <video
              src={masterFile}
              style={{ width: "100%" }}
              controls
              controlsList="nodownload"
            />
          ) : typeOfMasterFile.includes("mp3") ? (
            <audio src={masterFile} controls />
          ) : typeOfMasterFile.includes("pdf") ? (
            <iframe
              src={masterFile}
              style={{ height: "400px" }}
              frameborder="0"
            ></iframe>
          ) : null}
        </Box>
      )}
    </Stack>
  );
};

export default SubmittedFilesPreview;
